import classNames from 'classnames';
import styles from './view-content-button.module.css';

interface ViewContentButtonProps {
  handleView: () => void;
  caption: string;
}

const ViewContentButton: React.FC<ViewContentButtonProps> = ({
  caption,
  handleView,
}) => {
  return (
    <div
      className={classNames(
        styles.viewContent,
        'trojan-neumorphism-box trojan-neumorphism-box-shadow '
      )}
    >
      <div>{caption}</div>
      <div className={styles.viewButton} onClick={handleView}>
        View
      </div>
    </div>
  );
};

export default ViewContentButton;
